<template>
  <rest
    :remote="remote"
    :table-columns="tableColumns"
    :formInitialize="formInitialize"
    :form-rules="formRules"
    :exportable="true"
    :export-visible="true"
    :use-drawer="true"
    drawer-width="50%"
    :create-able="true" :update-able="true" :delete-able="true"
  >
  </rest>
</template>

<script>

import Rest from '@/components/Spring/Rest'

export default {
  name: 'xsArgsPays',
  components: { Rest },

  data () {
    return {
      remote: {
        path: 'channel',
        resource: this.$options.name,
        realtime: true
      },
      formInitialize: {
        args: [],
        open: true,
        debug: true,
        timeout: 3000
      },
      formRules: {
        ownerType: [{ required: true, message: '请填写 ownerType' }],
        argsId: [{ required: true, message: '请填写 argsId' }],
        logicId: [{ required: true, message: '请填写 logicId' }],
        name: [{ required: true, message: '请填写 name' }],
        args: [{ required: true, message: '请填写 args' }],
        open: [{ required: true, message: '请填写 open' }],
        debug: [{ required: true, message: '请填写 debug' }],
        timeout: [{ required: true, message: '请填写 timeout' }]
      },
      listeners: {
      }
    }
  },
  computed: {
    tableColumns () {
      return [
        { label: 'ID', prop: 'id', hiddenForm: true },
        { label: 'OwnerType', prop: 'ownerType' },
        { label: 'ArgsId', prop: 'argsId' },
        { label: 'LogicId', prop: 'logicId' },
        { label: 'Name', prop: 'name' },
        { label: 'Args', prop: 'args', type: 'textarea' },
        { label: 'Open', prop: 'open', type: 'switch' },
        { label: 'Debug', prop: 'debug' },
        { label: 'Timeout', prop: 'timeout' }
      ]
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style scoped>
</style>
